import React from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

let styles;

const ContentContainer = props => (
  <div className={css(styles.container, props.styles, props.reverse ? styles.reverse : null)}>
    { props.children }
  </div>
);

export default ContentContainer;

ContentContainer.defaultProps = {
  styles: null,
  reverse: false,
  children: [],
};

ContentContainer.propTypes = {
  styles: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ])),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node).isRequired,
    PropTypes.object,
  ]),
  reverse: PropTypes.bool,
};

styles = StyleSheet.create({
  container: {
    boxSizing: 'border-box',
    width: Theme.container_width,
    maxWidth: '100vw',
    padding: '0 15px',
    marginRight: 'auto',
    marginLeft: 'auto',

    [Theme.mobile_query]: {
      maxWidth: '100%',
    },
  },
  reverse: {
    flexDirection: 'row-reverse',
  },
});



// WEBPACK FOOTER //
// ./src/components/ContentContainer/index.js